(function () {
  'use strict';

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function haversineDistance(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLng = ((lng2 - lng1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // Shopify limite shop.metaobjects.<type>.values à 50 éléments par défaut en Liquid.
  // La section utilise {% paginate %} (jusqu'à 250/page). Le nom du paramètre de page
  // (ex. ?page_a5770521=2) est généré dynamiquement par Shopify et ne doit pas être
  // deviné : on suit simplement le lien "next" fourni par Liquid (data-next-page-url),
  // page après page, jusqu'à ce qu'il n'y en ait plus.
  function fetchAllPages(sectionId, nextUrl, acc, maxPages) {
    if (!nextUrl || maxPages <= 0) {
      return Promise.resolve(acc);
    }
    return fetch(nextUrl)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('StoreLocatorData-' + sectionId);
        if (!el) return acc;
        var items = [];
        try {
          items = JSON.parse(el.textContent);
        } catch (e) {
          console.error('Store locator : page suivante invalide', e);
          return acc;
        }
        var merged = acc.concat(items);
        var next = el.dataset.nextPageUrl || '';
        return fetchAllPages(sectionId, next, merged, maxPages - 1);
      })
      .catch(function (e) {
        console.error('Store locator : échec du chargement de la page suivante', e);
        return acc;
      });
  }

  function initStoreLocator(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var sectionId = root.dataset.sectionId;
    var dataEl = document.getElementById('StoreLocatorData-' + sectionId);
    var mapEl = document.getElementById('StoreLocatorMap-' + sectionId);

    if (!mapEl || !dataEl || typeof window.L === 'undefined') return;

    var retailers = [];
    try {
      retailers = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('Store locator : données revendeurs invalides', e);
    }

    var nextUrl = dataEl.dataset.nextPageUrl || '';
    if (nextUrl) {
      // Limite de sécurité (20 pages x 250 = 5000 revendeurs) pour éviter toute boucle infinie.
      fetchAllPages(sectionId, nextUrl, retailers, 20).then(function (all) {
        continueInit(root, all);
      });
      return;
    }
    continueInit(root, retailers);
  }

  function continueInit(root, retailers) {
    retailers = retailers.filter(function (r) {
      return r.lat && r.lng;
    });

    var sectionId = root.dataset.sectionId;
    var mapEl = document.getElementById('StoreLocatorMap-' + sectionId);
    var listEl = document.getElementById('StoreLocatorList-' + sectionId);
    var emptyEl = document.getElementById('StoreLocatorEmpty-' + sectionId);
    var searchInput = document.getElementById('StoreLocatorSearch-' + sectionId);
    var locateBtn = document.getElementById('StoreLocatorLocate-' + sectionId);
    var countrySelect = document.getElementById('StoreLocatorCountry-' + sectionId);

    var lat = parseFloat(root.dataset.lat) || 46.6;
    var lng = parseFloat(root.dataset.lng) || 2.2;
    var zoom = parseInt(root.dataset.zoom, 10) || 5;
    var tileStyle = root.dataset.tile;

    var map = window.L.map(mapEl).setView([lat, lng], zoom);

    var tileUrl =
      tileStyle === 'light'
        ? 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
        : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    var attribution =
      tileStyle === 'light'
        ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        : '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';

    window.L.tileLayer(tileUrl, { attribution: attribution, maxZoom: 19 }).addTo(map);

    var hasClustering = typeof window.L.markerClusterGroup === 'function';
    var clusterGroup = hasClustering ? window.L.markerClusterGroup({ maxClusterRadius: 50 }) : null;
    if (clusterGroup) map.addLayer(clusterGroup);

    var markers = {};
    var bounds = [];

    retailers.forEach(function (r) {
      var marker = window.L.marker([r.lat, r.lng]);
      var popupHtml =
        '<div class="store-locator__popup">' +
        '<strong>' + escapeHtml(r.name) + '</strong><br>' +
        (r.address ? escapeHtml(r.address) + '<br>' : '') +
        (r.postal_code || r.city ? escapeHtml((r.postal_code + ' ' + r.city).trim()) + '<br>' : '') +
        (r.phone ? '<a href="tel:' + escapeHtml(r.phone) + '">' + escapeHtml(r.phone) + '</a><br>' : '') +
        (r.website
          ? '<a href="' + escapeHtml(r.website) + '" target="_blank" rel="noopener">Site web</a>'
          : '') +
        '</div>';
      marker.bindPopup(popupHtml);
      if (clusterGroup) {
        clusterGroup.addLayer(marker);
      } else {
        marker.addTo(map);
      }
      markers[r.id] = marker;
      bounds.push([r.lat, r.lng]);
    });

    function fitToMarkers(items) {
      var pts = items.map(function (r) {
        return [r.lat, r.lng];
      });
      if (pts.length) {
        map.fitBounds(pts, { padding: [40, 40], maxZoom: 12 });
      }
    }

    if (bounds.length) {
      fitToMarkers(retailers);
    }

    function setMarkersVisible(visibleIds) {
      if (!clusterGroup) {
        retailers.forEach(function (r) {
          var marker = markers[r.id];
          if (!marker) return;
          var shouldShow = visibleIds.has(r.id);
          var onMap = map.hasLayer(marker);
          if (shouldShow && !onMap) marker.addTo(map);
          if (!shouldShow && onMap) map.removeLayer(marker);
        });
        return;
      }
      clusterGroup.clearLayers();
      retailers.forEach(function (r) {
        if (visibleIds.has(r.id)) clusterGroup.addLayer(markers[r.id]);
      });
    }

    if (countrySelect) {
      var countries = Array.from(
        new Set(retailers.map(function (r) { return r.country; }).filter(Boolean))
      ).sort(function (a, b) { return a.localeCompare(b); });
      var allLabel = root.dataset.countryFilterAllLabel || 'Tous les pays';
      var allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = allLabel;
      countrySelect.appendChild(allOption);
      countries.forEach(function (c) {
        var opt = document.createElement('option');
        opt.value = c;
        opt.textContent = c;
        countrySelect.appendChild(opt);
      });
    }

    function renderList(items) {
      listEl.innerHTML = '';
      if (!items.length) {
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;
      items.forEach(function (r) {
        var li = document.createElement('li');
        li.className = 'store-locator__item';
        li.tabIndex = 0;
        li.innerHTML =
          '<strong>' + escapeHtml(r.name) + '</strong>' +
          '<span>' + escapeHtml(r.address) + '</span>' +
          '<span>' + escapeHtml((r.postal_code + ' ' + r.city).trim()) + '</span>' +
          (r._distance !== undefined
            ? '<span class="store-locator__distance">' + r._distance.toFixed(1) + ' km</span>'
            : '');
        var selectItem = function () {
          var marker = markers[r.id];
          if (!marker) return;
          if (clusterGroup && clusterGroup.hasLayer(marker)) {
            clusterGroup.zoomToShowLayer(marker, function () {
              marker.openPopup();
            });
          } else {
            map.setView(marker.getLatLng(), 14);
            marker.openPopup();
          }
        };
        li.addEventListener('click', selectItem);
        li.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectItem();
          }
        });
        listEl.appendChild(li);
      });
    }

    renderList(retailers);

    function applyFilters() {
      var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var country = countrySelect ? countrySelect.value : '';
      var filtered = retailers.filter(function (r) {
        var matchesQuery =
          !q ||
          (r.city && r.city.toLowerCase().indexOf(q) !== -1) ||
          (r.postal_code && r.postal_code.toLowerCase().indexOf(q) !== -1) ||
          (r.name && r.name.toLowerCase().indexOf(q) !== -1);
        var matchesCountry = !country || r.country === country;
        return matchesQuery && matchesCountry;
      });
      renderList(filtered);
      setMarkersVisible(new Set(filtered.map(function (r) { return r.id; })));
      if (filtered.length) fitToMarkers(filtered);
    }

    if (searchInput) {
      searchInput.addEventListener('input', applyFilters);
    }

    if (countrySelect) {
      countrySelect.addEventListener('change', applyFilters);
    }

    if (locateBtn && navigator.geolocation) {
      locateBtn.addEventListener('click', function () {
        locateBtn.disabled = true;
        navigator.geolocation.getCurrentPosition(
          function (pos) {
            locateBtn.disabled = false;
            var userLat = pos.coords.latitude;
            var userLng = pos.coords.longitude;
            var country = countrySelect ? countrySelect.value : '';
            var sorted = retailers
              .filter(function (r) {
                return !country || r.country === country;
              })
              .map(function (r) {
                r._distance = haversineDistance(userLat, userLng, r.lat, r.lng);
                return r;
              })
              .sort(function (a, b) {
                return a._distance - b._distance;
              });
            renderList(sorted);
            setMarkersVisible(new Set(sorted.map(function (r) { return r.id; })));
            map.setView([userLat, userLng], 11);
            window.L.circleMarker([userLat, userLng], { radius: 8, color: '#1a73e8' })
              .addTo(map)
              .bindPopup('Vous êtes ici')
              .openPopup();
          },
          function () {
            locateBtn.disabled = false;
            alert("Impossible d'obtenir votre position.");
          }
        );
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.store-locator').forEach(initStoreLocator);
  });

  // Réinitialisation dans l'éditeur de thème (drag & drop / re-render de section)
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.store-locator');
    if (root) {
      root.dataset.initialized = 'false';
      initStoreLocator(root);
    }
  });
})();
